export default "__VITE_ASSET__B_7t1SUW__"